export const INITIAL_FORM = {
  organization_name: "",
  contact_name: "",
  email: "",
  program_name: "",
  city_state: "",
  funding_amount: "",

  target_population: "",
  age_range: "",
  location_served: "",
  why_group_matters: "",

  what_is_happening: "",
  why_problem_matters: "",
  who_is_affected: "",
  if_no_response: "",

  missing_needs: [],
  missing_needs_other: "",
  unaddressed_needs_text: "",

  program_description: "",
  program_frequency: "",
  program_location: "",
  people_served: "",
  what_makes_meaningful: "",

  partners: [],
  partners_other: "",
  partners_explanation: "",

  cost_categories: [],
  cost_categories_other: "",
  cost_description: "",
  budget_estimates: "",

  proposal_type: "Full Grant Proposal",
};

export const MISSING_NEEDS = [
  "Safe space", "Mentoring", "Transportation", "Tutoring", "Job training",
  "Mental health support", "Food access", "Technology", "Case management",
  "Family support", "Positive community",
];

export const PARTNER_OPTIONS = [
  "Schools", "Churches", "Community organizations", "Parents",
  "Local businesses", "Police or court partners", "Social workers",
  "Volunteers", "Colleges", "Employers",
];

export const COST_OPTIONS = [
  "Staff", "Space", "Food", "Transportation", "Supplies", "Technology",
  "Instructors", "Stipends", "Marketing", "Insurance", "Evaluation",
  "Administrative support",
];

export const PROPOSAL_TYPES = [
  { value: "Full Grant Proposal", desc: "Complete proposal with 10 standard sections." },
  { value: "Letter of Inquiry", desc: "Short letter introducing your need before a full ask." },
  { value: "Sponsorship Request", desc: "Warm appeal to corporate or community sponsors." },
  { value: "Program Summary", desc: "Concise overview of your program at a glance." },
  { value: "Budget Narrative", desc: "Explanation of how funding will be spent." },
  { value: "Funder Email", desc: "Short, ready-to-send outreach email." },
  { value: "One-Page Concept Paper", desc: "Single-page idea summary for funders." },
];

export const STEPS = [
  { id: 1, label: "Basics", title: "Basic Information", subtitle: "Tell us about your organization." },
  { id: 2, label: "Who", title: "Who Do You Want to Help?", subtitle: "Describe the people you serve." },
  { id: 3, label: "Problem", title: "What Problem Are You Addressing?", subtitle: "Help funders see what you see." },
  { id: 4, label: "Needs", title: "What Needs Are Missing?", subtitle: "Identify gaps in support." },
  { id: 5, label: "Response", title: "Your Program Response", subtitle: "How will you respond to the need?" },
  { id: 6, label: "Partners", title: "Partners", subtitle: "Who will you work with?" },
  { id: 7, label: "Costs", title: "Major Costs", subtitle: "What will the funding pay for?" },
  { id: 8, label: "Format", title: "Proposal Type", subtitle: "Choose what we should create." },
];
